
import { computed, defineComponent } from 'vue';
import { INotaFiscal } from '@/models/Entidades/Fiscal/INotaFiscal';
import SelecionarCidade from '@/components/Cadastros/Localizacoes/Cidades/SelecionarCidade.vue';
import ServicoCidade from '@/servicos/Cadastros/Localizacoes/ServicoCidade';

export default defineComponent({
  name: 'NotaFiscalEntrega',
  props: {
    notaFiscal: {
      type: Object as () => INotaFiscal,
      required: true,
    },
    editavel: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    SelecionarCidade,
  },
  emits: ['update:notaFiscal'],
  setup(props, { emit }) {
    const servicoCidade = new ServicoCidade();
    const computedNotaFiscal = computed({
      get: () => props.notaFiscal,
      set: (val: INotaFiscal) => {
        emit('update:notaFiscal', val);
      },
    });

    async function obterDadosCidade() {
      console.log('chamou aqui');
      const cidade = await servicoCidade.obterCidadeDetalhada(computedNotaFiscal.value.destinatario.enderecoDiferente.codigoCidade);
      computedNotaFiscal.value.destinatario.enderecoDiferente.codigoMunicipio = Number(cidade.codigoIbge);
      computedNotaFiscal.value.destinatario.enderecoDiferente.uf = cidade.uf;
      computedNotaFiscal.value.destinatario.enderecoDiferente.nomeCidade = cidade.cidade;
    }

    return {
      computedNotaFiscal,
      obterDadosCidade,
    };
  },
});
